<template>
  <div>
    <RightDetail
      v-if="pageStatus === 'rightDetail'"
      @changeToLeader="changeToLeader()"
    ></RightDetail>
    <RightLeader
      v-if="pageStatus === 'leader'"
      @changeToDetail="changeToDetail"
    ></RightLeader>
  </div>
</template>
<script>
import RightDetail from "./rightDeatail/RightDetail";
import RightLeader from "./rightLeader/RightLeader";
export default {
  name: "Right",
  components: {
    RightDetail,
    RightLeader,
  },
  data() {
    return {
      pageStatus: "leader",
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      // this.toLedgerData.page = val.page;
      // this.toLedgerData.pageSize = val.pageSize;
      // this.toLedgerData.queryContractId = val.queryContractId;
      // this.toLedgerData.queryAssetAddress = val.queryAssetAddress;
      // this.toLedgerData.queryCompanyName = val.queryCompanyName;
      // this.toLedgerData.queryAssetId = val.queryAssetId;
      // this.toLedgerData.queryCompanyId = val.queryCompanyId;
      // this.toLedgerData.queryCustomerName = val.queryCustomerName;
      // this.toLedgerData.queryRadioStatus = val.queryRadioStatus;
      // this.toDetailData = {
      //   id: val.contractDetailsId,
      //   contractId: val.contractId,
      //   companyId: val.companyId,
      //   managementLayer: val.managementLayer,
      // };
      console.log(val)
      this.pageStatus = "rightDetail";
      
    },
  },
};
</script>

<style>
</style>